









import React from "react";
import "../../styles/DryBulkCarriers.css";
import bulkCarrierImage from "../../images/drybulk-slider.jpg";
import bulk1 from "../../assets/bulk1.jpg";
import bulk2 from "../../assets/bulk2.jpg";
import bulkIcon from "../../assets/service-icon.png"; // Import the icon
import { Link } from "react-router-dom";

const DryBulkCarriers = () => {
  return (
    <div className="bulk-container">
      {/* Image Slider - Full width like homepage */}
      <div className="bulk-image-slider">
        <img src={bulkCarrierImage} alt="Dry Bulk Carriers Slider" />
      </div>

      {/* Main Content Container */}
      <div className="bulk-content">
        {/* Content Card with title inside */}
        <div className="bulk-card">
          {/* Title with Icon - Added with blue style */}
          <div className="bulk-title-header">
            <img src={bulkIcon} alt="Bulk Carrier Service" className="bulk-title-icon rotate-on-hover" />
            <h3 className="bulk-title-text">Dry Bulk Carriers</h3>
          </div>
          
          {/* Left Side - Images */}
          <div className="card-left">
            <div className="bulk-image-container first-image">
              <img src={bulk1} alt="Bulk Cargo Loading" className="bulk-img" />
            </div>
            <div className="bulk-image-container second-image">
              <img src={bulk2} alt="Bulk Cargo Loading" className="bulk-img" />
            </div>
          </div>

          {/* Right Side - Text Content */}
          <div className="card-right">
            <p className="bulk-text">
              India is a country rich in mineral resources and an abundance of agricultural produce,
              substantial quantities of which are exported.
            </p>
            <p className="bulk-text">
              Puyvast has been associated with the carriage of dry bulk from east and west coast ports of India
              to destinations in Europe as well as Far East, servicing both Domestic and International trading houses.
            </p>
            <p className="bulk-text">
              Puyvast operated vessels are certified to load dry bulk commodities such as Rice, Sugar, Wheat, Maize, 
              SBM, RSM, Chrome, Ilmenite, Baryte, Garnet, Feldspar, Manganese and Pig iron.
            </p>
            <p className="bulk-text">
              With a team of competent supercargoes and suitable stevedoring equipment to handle varied dry bulk 
              commodities, Puyvast is in a position to offer dependable ocean carriage to the dry bulk trade.
            </p>
          </div>
        </div>
      </div>

      {/* Footer - Same as homepage */}
      <footer className="footer">
        <div className="footer-container">
          {/* Left Section - CIN & Links */}
          <div className="footer-left">
            <p>CIN Number: U63030KA2022PTC161825</p>
            <p>
              <Link to="/privacy-statement" className="footer-link">Privacy Statement</Link> |
              <Link to="/terms-of-use" className="footer-link"> Terms Of Use</Link>
            </p>
          </div>

          {/* Center - Copyright */}
          <div className="footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>

          {/* Right Section - Registered Office */}
          <div className="footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt. Ltd.,</p>
            <p>PuyVast House </p>
            <p>4th Floor ,#6, Harris Road, Benson Town,<br></br> Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default DryBulkCarriers;